import { AccredibleGeoCoordinates, AccredibleGeoViewport } from '@accredible-frontend-v2/models';

export enum DistanceMetric {
  MILES = 'mi',
  KILOMETRES = 'km',
}

export interface LocationSearchParams {
  types: '(cities)';
  input: string;
  latitude: number;
  longitude: number;
}

export interface LocationSearch {
  predictions: LocationSearchPrediction[];
  status: string;
}

export interface LocationSearchPrediction {
  description: string;
  matched_substrings: MatchedSubstring[];
  place_id: string;
  reference: string;
  structured_formatting: StructuredFormatting;
  terms: Term[];
  types: Type[];
}

interface MatchedSubstring {
  length: number;
  offset: number;
}

interface StructuredFormatting {
  main_text: string;
  main_text_matched_substrings: MatchedSubstring[];
  secondary_text: string;
}

interface Term {
  offset: number;
  value: string;
}

enum Type {
  Geocode = 'geocode',
  Locality = 'locality',
  Political = 'political',
}

export interface PlaceDetailsParams {
  place_id: string;
}

export interface PlaceDetails {
  html_attributions: any[];
  result: PlaceDetailsResult;
  status: string;
}

export interface PlaceDetailsResult {
  address_components: AddressComponent[];
  adr_address: string;
  formatted_address: string;
  geometry: Geometry;
  icon: string;
  name: string;
  photos: Photo[];
  place_id: string;
  reference: string;
  types: string[];
  url: string;
  utc_offset: number;
  vicinity: string;
}

interface AddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

interface Geometry {
  location: AccredibleGeoCoordinates;
  viewport: AccredibleGeoViewport;
}

interface Photo {
  height: number;
  html_attributions: string[];
  photo_reference: string;
  width: number;
}
